module.exports = __webpack_public_path__ + "img/旋转木马.f7b24669.png";